import { DOWNLOAD_EVENTS, pushButtonClick } from '../../lib/analytics';

export const CertificateButton = ({
  fileName = 'Root-Russian-Trusted-CA.cer',
  className = '',
  children,
}) => {
  const trackDownload = () => {
    if (typeof window === 'undefined') return;

    const eventAction = DOWNLOAD_EVENTS[window.location.pathname];
    if (!eventAction) return;

    pushButtonClick({
      name: typeof children === 'string' ? children : undefined,
      eventAction,
    });
  };

  return (
    <div className={`certificate-button ${className}`.trim()}>
      <a
        className="link-button"
        href={`../../assets/files/${fileName}`}
        download={fileName}
        onClick={trackDownload}
        title="Цифровой сертификат безопасности (SSL) - это сертификат безопасности, необходимый для безопасной передачи данных с помощью протокола шифрования. Использование этого протокола гарантирует безопасность обмена данными между сервером web-портала и браузером пользователя. Другими словами, SSL-сертификат защищает пользователей от хищения или подмены данных."
      >
        {children}
      </a>
    </div>
  );
};
